import React from 'react';

// Styles & Assets
import styles from './ChartButton.module.css';

// Interfaces
interface ButtonChart {
    id: string,
    indicators: string[],
    color: string,
    text: string,
}

// ChartButton: renders a button with a coloured circle and
// a text. Used in the PatientChartButtons. Props:
//  -button: button with id, color and text
//  -activeButton: id of the active button to color it.
//  -onClick: function that receives a number with the clicked button
const ChartButton: React.FC<{
    button: ButtonChart,
    activeButton: boolean,
    onClick: () => void,
}> = ({ button, activeButton, onClick }) => {

    return (
        <button onClick={onClick} className={styles.buttonCharts}>
            <div style={{ backgroundColor: activeButton ? button.color : '' }} className={styles.circle} />
            <span>{button.text}</span>
        </button>
    );
};

export default ChartButton;